import { render, staticRenderFns } from "./weeks_header_item.vue.js?vue&type=template&id=4a498854!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./weeks_header_item.vue?vue&type=template&id=4a498854"
import script from "./weeks_header_item.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./weeks_header_item.vue?vue&type=script&lang=js"
export * from "./weeks_header_item.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./weeks_header_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports